export default "__VITE_ASSET__b7358b3a__"